<template>
  <!-- 官网列表,官网详情头部下方没有搜索的导航 -->
  <div class="noSearchHeaderBottom">
    <div class="bottom-head">
      <el-row class="contain row-bg" type="flex" justify="space-between">
        <el-col :span="12">
          <div class="head-logo">
            <img src="../../assets/img/logo7.png" alt />
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-menu
              @select="handleSelect"
              mode="horizontal"
              router
              :default-active="activeIndexJ"
            >
              <!-- <template v-for="(item, i) in routers">
                                <el-menu-item
                                    v-if="item.index == 1"
                                    :key="i"
                                    :index="item.path"
                                >{{ item.name }}</el-menu-item>
                            </template>-->
              <el-menu-item index="/index">首页</el-menu-item>
              <el-menu-item index="/ForumIndex">中医讲堂</el-menu-item>
              <el-menu-item index="/ancPre">古方大全</el-menu-item>
              <el-menu-item index="/HerbalMedicineIndex">中草药</el-menu-item>
              <el-menu-item index="/LibraryIndex">中医文库</el-menu-item>
              <el-menu-item index="/JingLuoIndex">经络穴位</el-menu-item>
              <el-menu-item index="/ShopIndex">药城首页</el-menu-item>
            </el-menu>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "noSearchHeaderBottom",
  data() {
    return {
      seachInput: "",
      routers: [],
    };
  },

  methods: {
    handleSelect(index) {
      this.activeIndex = index;
    }
  },
  created() {
    this.routers = this.$router.options.routes[0].children;
    // this.activeIndexJ = this.$route.path;
    if (
      this.$route.path == "/ForumDetailv" ||
      this.$route.path == "/ForumDetailw"
    ) {
      this.activeIndexJ = "/ForumIndex";
    }
    if (this.$route.path == "/HerbalMedicineDetail") {
      this.activeIndexJ = "/HerbalMedicineIndex";
    }
    if (this.$route.path == "/weiKuDetail") {
      this.activeIndexJ = "/LibraryIndex";
    }
    if (
      this.$route.path == "/JingLuoDetail" ||
      this.$route.path == "/xueWeiDetail" ||
      this.$router.path == "/shuxueDetail"
    ) {
      this.activeIndexJ = "/JingLuoIndex";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bottom-head .is-active {
  color: black;
  border-bottom: 2px solid #f64420;
  border-bottom-color: #f64420;
  background-color: none;
}
.bottom-head .el-menu-item {
  color: #777f8f !important;
}

.head-title {
  font-size: 12px;
  line-height: 40px;
  letter-spacing: 1.9px;
  color: #ffffff;
  opacity: 0.4;
}
.top-head {
  width: 100%;
  height: 40px;
  background-color: #333333;
}
.top-head .el-col,
.top-head .el-row {
  height: 100%;
}
.el-menu-black > .el-menu-item {
  line-height: 40px;
  height: 40px;
  opacity: 0.4;
  font-size: 12px;
}
.el-menu-black {
  line-height: 40px;
  height: 40px;
  float: right;
}
.el-menu-white {
  width: 650px;
  border: none;
  float: right;
}
.bottom-head {
  padding: 20px 0px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
}
.head-logo {
  max-height: 60px;
}
.head-logo img {
  display: block;
  height: 60px;
}
/* header .el-input-group {
  width: 252px;
  margin-top: 15px;
  float: right;
} */
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/noSearchHeaderBottom.vue